import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { HeaderService } from './header.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const PHONETIC_LOOKUP_DICT = {
  A: 'Alpha',
  B: 'Bravo',
  C: 'Charlie',
  D: 'Delta',
  E: 'Echo',
  F: 'Foxtrot',
  G: 'Golf',
  H: 'Hotel',
  I: 'India',
  J: 'Juliet',
  K: 'Kilo',
  L: 'Lima',
  M: 'Mike',
  N: 'November',
  O: 'Oscar',
  P: 'Papa',
  Q: 'Quebec',
  R: 'Romeo',
  S: 'Sierra',
  T: 'Tango',
  U: 'Uniform',
  V: 'Victor',
  W: 'Whiskey',
  X: 'X-ray',
  Y: 'Yankee',
  Z: 'Zulu',
  a: 'alpha',
  b: 'bravo',
  c: 'charlie',
  d: 'delta',
  e: 'echo',
  f: 'foxtrot',
  g: 'golf',
  h: 'hotel',
  i: 'india',
  j: 'juliet',
  k: 'kilo',
  l: 'lima',
  m: 'mike',
  n: 'november',
  o: 'oscar',
  p: 'papa',
  q: 'quebec',
  r: 'romeo',
  s: 'sierra',
  t: 'tango',
  u: 'uniform',
  v: 'victor',
  w: 'whiskey',
  x: 'x-ray',
  y: 'yankee',
  z: 'zulu',
  1: 'One',
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
  9: 'Niner',
  0: 'Zero',
  '@': 'At symbol',
  '!': 'Exclamation Point',
  '#': 'Pound Sign',
  $: 'Dollar',
  '%': 'Percentage',
  '&': 'Ampersand',
  '(': 'Open parenthesis',
  ')': 'Close parenthesis',
  '*': 'Asterisk',
  '+': 'Plus',
  ',': 'Comma',
  '-': 'Hyphen',
  '/': 'Slash',
  ':': 'Colon',
  ';': 'Semicolon',
  '<': 'Less than',
  '=': 'Equals',
  '>': 'Greater than',
  '?': 'Question mark',
  _: 'Underscore',
  '': ' '
};

@Injectable({
  providedIn: 'root'
})
export class UserAuthInfoService {
  constructor(
  ) {}

  getPhoneticSpelling(input) {
    let i = 0;
    const spellingList = [];
    // 3-mod of number;
    let emptyValues = 0;

    if (input != null) {
      if (input.length % 3 !== 0) {
        emptyValues = 3 - (input.length % 3);
      }
      while (i < input.length + emptyValues) {
        const character = input.charAt(i);
        if (/^[a-z]$/.test(character) === true) {
          spellingList[i] = 'Lower case:  ' + PHONETIC_LOOKUP_DICT[character];
        } else if (/^[A-Z]$/.test(character) === true) {
          spellingList[i] = 'Upper case:  ' + PHONETIC_LOOKUP_DICT[character];
        } else {
          spellingList[i] = PHONETIC_LOOKUP_DICT[character];
        }
        i++;
      }
    }
    return spellingList;
  }
}
